module.exports = __webpack_public_path__ + "static/media/bagrik.2aa51b5d.svg";